import { ChevronLeft, ChevronRight, X } from "lucide-react";

// Compact bar shown during a walkthrough so the page stays visible.
export default function WalkBar({ walk, step, onBack, onNext, onEnd }) {
  const n = walk.steps.length;
  const s = walk.steps[step];
  return (
    <section className="fixed inset-x-2 bottom-2 z-[61] rounded-2xl border border-[#0053DA]/30 bg-white p-3 shadow-2xl sm:inset-x-auto sm:bottom-6 sm:right-6 sm:w-[380px]" data-testid="edgar-walk">
      <div className="flex items-center gap-2">
        <span className="inline-flex h-6 w-6 items-center justify-center rounded-full bg-[#0053DA] font-serif text-xs font-bold italic text-white" aria-hidden>E</span>
        <p className="min-w-0 flex-1 truncate text-xs font-bold text-slate-900">{walk.title}</p>
        <span className="font-mono text-[11px] text-slate-500" data-testid="edgar-walk-count">Step {step + 1} of {n}</span>
        <button type="button" onClick={onEnd} aria-label="End walkthrough" className="rounded-full p-1 text-slate-500 hover:bg-slate-100" data-testid="edgar-walk-end"><X className="h-4 w-4" /></button>
      </div>
      <p className="mt-2 text-sm text-slate-800" data-testid="edgar-walk-text">{s.text}</p>
      <div className="mt-2.5 h-1 overflow-hidden rounded-full bg-slate-100"><div className="h-full rounded-full bg-[#0053DA] transition-[width] duration-300" style={{ width: `${((step + 1) / n) * 100}%` }} /></div>
      <div className="mt-2.5 flex justify-between gap-2">
        <button type="button" onClick={onBack} disabled={!step} data-testid="edgar-walk-back"
          className="inline-flex items-center gap-1 rounded-full border border-slate-300 px-3 py-1.5 text-xs font-semibold text-slate-700 disabled:opacity-40"><ChevronLeft className="h-3.5 w-3.5" /> Back</button>
        <button type="button" onClick={onNext} data-testid="edgar-walk-next"
          className="inline-flex items-center gap-1 rounded-full bg-[#0053DA] px-4 py-1.5 text-xs font-semibold text-white transition-colors hover:bg-[#0041B0]">
          {step + 1 === n ? "Done" : <>Next <ChevronRight className="h-3.5 w-3.5" /></>}
        </button>
      </div>
    </section>
  );
}
